<template>
    <b-modal :id="modalId" hide-footer hide-header no-close-on-backdrop no-close-on-esc>
        <div id="header" class="mb-2">
            <span class="title">{{ $t('okr.modal.objective.duplicate') }}</span>
            <i class="close-button fas fa-times" @click="closeModal" />
        </div>
        <div class="body">
            <div>
                <Periods
                    notGetActive
                    lazyLoading
                    applyScopeNotArchived
                    :value.sync="$v.form.period.$model"
                    :placeholder="$t('form.placeholder.selectTheDesiredPeriod')"
                    :label="$t('form.label.period')"
                    :multiple="false"
                    :hideSelectedOptions="false"
                />
            </div>
            <edit-key-results
                :keyResults="keyResultOptions"
                :isSubmitting="isSubmitting"
                :loader="loader"
                @key-result-updated="onKeyResultUpdated"
                @submit="onClickSubmit"
                @cancel="closeModal"
            ></edit-key-results>
        </div>
    </b-modal>
</template>

<script>
import EditKeyResults from './components/EditKeyResults.vue'
import ButtonLoader from '@/views/components/button-loader'
import { getObjective, getKeyResultsOfObject, createObjective, createKeyResult } from '../api'
import { success, danger } from '@/lib/notification'
import { Periods } from '@/views/components/fields'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'

export default {
    mixins: [validationMixin],
    components: {
        ButtonLoader,
        EditKeyResults,
        Periods,
    },
    data() {
        return {
            modalId: 'duplicate-objective-modal',
            isSubmitting: false,
            loader: false,
            objectiveId: this.$route.params.objectiveId,
            keyResultOptions: [],
            objectiveOptions: [],
            isKeyResultUpdated: false,
            form: {
                period: null,
            },
        }
    },
    validations: {
        form: {
            period: { required },
        },
    },
    created() {
        this.getObjectiveData()
        this.getActiveKRs()
    },
    mounted() {
        this.$bvModal.show(this.modalId)
        console.log(this.$route.path)
    },
    methods: {
        onClickSubmit() {
            this.isSubmitting = true
            this.objectiveOptions.period_id = this.form.period.value
            this.objectiveOptions.user_id = this.$store.state.currentUser.user.id
            createObjective(this.objectiveOptions)
                .then(({ data }) => {
                    this.keyResultOptions.forEach((keyResultsData) => {
                        keyResultsData.current_value = keyResultsData.start_value
                        keyResultsData.last_checkin_id = null
                        keyResultsData.progress = 0
                        keyResultsData.objective_id = data.id
                        createKeyResult(data.id, keyResultsData)
                    })
                    this.$store.dispatch('getOKRsFromAPI')
                    this.showSuccessNotification()
                    this.closeModal()
                    this.$emit('onCreatedObjective')
                })
                .catch((error) => {
                    console.error(error)
                    this.showErrorNotification()
                })
                .finally(() => {
                    this.isSubmitting = false
                })
        },
        async getObjectiveData() {
            try {
                const { data } = await getObjective(this.objectiveId)
                this.form = {
                    period: this.updatePeriod(data.period),
                }
                this.objectiveOptions = data
            } catch (error) {
                console.error(error)
                this.showErrorNotification()
            }
        },
        async getActiveKRs() {
            this.loader = true
            try {
                const { data } = await getKeyResultsOfObject(this.objectiveId)
                this.keyResultOptions = Object.values(data)
            } catch (error) {
                console.error(error)
                this.showErrorNotification()
            } finally {
                this.loader = false
            }
        },
        onKeyResultUpdated(keyResult) {
            this.isKeyResultUpdated = true
            this.keyResultOptions = keyResult
        },
        updatePeriod({ id, name }) {
            return {
                value: id,
                label: name,
            }
        },
        mapToOptions(keyResults) {
            return keyResults.map((kr) => ({
                value: kr.id,
                title: kr.title,
                start_value: kr.start_value,
                target_value: kr.target_value,
            }))
        },
        showSuccessNotification() {
            success(
                this.$t('notification.duplicatedSuccessfully', {
                    item: this.$t('okr.okrs'),
                })
            )
        },
        showErrorNotification() {
            danger()
        },
        closeModal() {
            this.$router.back()
        },
    },
}
</script>

<style lang="scss" scoped>
#header {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .title {
        font-size: 24px;
        font-weight: 700;
        text-align: left;
        color: #009ada;
    }

    .close-button {
        color: #3b3f4e;
        cursor: pointer;
        font-size: 18px;
    }

    .border-color-kr {
        border-color: e8e8e8;
    }
}

.label-style {
    color: #022b4f;
    font-size: 16px;
    font-weight: 700;
}

::v-deep legend {
    @extend .label-style;
}

::v-deep label {
    @extend .label-style;
}
</style>
